import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

function LoginPage({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   setError('');
  //   try {
  //     const response = await fetch('https://backend.ouest-pro-event.fr/login', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ email, password })
  //     });
  //     const data = await response.json();
  //     if (response.ok) {
  //       onLogin(data.user);
  //       navigate('/home');
  //     } else {
  //       setError(data.error || "Échec de la connexion");
  //     }
  //   } catch (err) {
  //     setError("Une erreur est survenue. Veuillez réessayer.");
  //   }
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      const response = await fetch('https://backend.ouest-pro-event.fr/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
      });
      const data = await response.json();
      if (response.ok) {
        // Stocker le token dans localStorage
        localStorage.setItem('adminToken', data.user.token);
        onLogin(data.user);
        navigate('/home');
      } else {
        setError(data.error || "Échec de la connexion");
      }
    } catch (err) {
      setError("Une erreur est survenue. Veuillez réessayer.");
    }
};

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="company-name">
          <h1>Ouest Pro Event</h1>
          <p className="company-subtitle">Solutions événementielles professionnelles</p>
        </div>
        <h2 className="login-title">Connexion Admin</h2>
        {error && <div className="error-message">{error}</div>}
        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Votre email"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Votre mot de passe"
              required
            />
          </div>
          <button type="submit" className="login-button">
            Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}

export default LoginPage;